// src/models/landing-page.js
import contactpersonservice from '@/services/contactpersonservice.js';

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
export class ContactPerson {
  constructor({
    id = null,
    city = '',
    email = '',
    firstname = '', 
    lastname = '',
    postalcode = '',
    street = '',
    telephone = '',
    addressId = null
  } = {}) {
    this.id = id
    this.addressId = addressId
    this.city = city
    this.email = email
    this.firstname = firstname
    this.lastname = lastname
    this.postalcode = postalcode
    this.street = street
    this.telephone = telephone
  }
}

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
//export function responseAdapter({ fields, sys }) {
//  return new Event({ ...fields, ...sys });
//}

export function responseAdapter(response) {

  let out = [];
  if(response == null){
    return out; 
  }
  else if (response.data != null && Array.isArray(response.data.content)) {
    response.data.content.forEach(element => {
      mapAndAdd(out, element)
    });
  }else if(response.data != null){
    mapAndAdd(out, response.data);
    return out[0];
  }else if(response != null){
    mapAndAdd(out, response);
    return out[0];
  }
  return out;
}

function mapAndAdd(out, element){
  out.push(new ContactPerson({ ...element }));
}

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async getAll() {
    return responseAdapter(await contactpersonservice.getMemberGroups());
  },
  async update(contactPersonId, contactPerson) {
    return responseAdapter(await contactpersonservice.update(contactPersonId, contactPerson));
  },
};
